import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AppProvider } from './contexts/AppContext';
import { loadWebAppConfig, shouldUseKeycloak } from './lib/config';
import { initDisabledAuth, initKeycloak } from './lib/session';
import './index.css';

async function boot(): Promise<void> {
  const config = await loadWebAppConfig();
  if (shouldUseKeycloak(config, window.location.hostname)) {
    await initKeycloak({
      url: config.keycloakUrl,
      realm: config.keycloakRealm,
      clientId: config.keycloakClientId,
      idpHint: config.keycloakIdpHint,
    });
  } else if (config.authDisabled || !shouldUseKeycloak(config, window.location.hostname)) {
    await initDisabledAuth();
  }
}

const host = document.getElementById('root');
if (!host) throw new Error('missing root');

void boot().then(() => {
  createRoot(host).render(
    <StrictMode>
      <BrowserRouter>
        <AppProvider>
          <App />
        </AppProvider>
      </BrowserRouter>
    </StrictMode>,
  );
});
